import * as React from 'react';
import { Text } from 'ilenia';
import { StyleSheet, css } from 'aphrodite';
import { Box } from '../Layout';
import { Tooltip } from './Tooltip';
import { TooltipSettings } from '../../Model';

export enum LabelSize {
    Small = 1,
    Bold = 2,
}

export interface Interpolations {
    [key: string]: string | number;
}
interface LabelProps extends React.HTMLProps<HTMLLabelElement> {
    label?: string;
    interpolations?: Interpolations;
    errorMode?: boolean;
    width?: string;
    tooltip?: TooltipSettings;
    labelSize?: LabelSize;
    mt?: number;
    mb?: number;
    disabled?: boolean;
}

export const Label: React.SFC<LabelProps> = (props) => {
    const { errorMode, width, tooltip, labelSize, mt, mb, disabled, ...rest } = props;

    const classNames = [
        styles.label,
        disabled && styles.disabled,
        errorMode && styles.labelError,
        labelSize === LabelSize.Bold ? styles.boldLabel : styles.smallLabel,
    ];

    return (
        <Box mt={mt} mb={mb} width={width}>
            <label className={css(...classNames)} {...rest}>
                <Text
                    id={props.label!}
                    interpolations={props.interpolations!}
                />
                {tooltip ? <Tooltip tooltipSettings={tooltip}/> : null}
            </label>
        </Box>
    );
};

Label.defaultProps = {
    labelSize: LabelSize.Bold,
    mt: 10,
    mb: 10,
};

const styles = StyleSheet.create({
    label: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#222222'
    },
    labelError: {
        color: '#fc4c5d'
    },
    smallLabel: {
        fontSize: '14px',
    },
    boldLabel: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    disabled: {
        color: 'rgb(231, 231, 231)'
    }
});
